import { INSTRUMENTATION_TYPES, ActionTypes as types } from '../constants'
import { getAnalyticsMeta } from './Actions'

export function changeThemeId(themeId) {
  const data = { crid: themeId }
  const pageGroup = 'main:consumer:p2p:gift:save'
  const pageName = `main:consumer:p2p:gift:save:${themeId}`

  return {
    type: types.THEME.CHANGE_THEME_ID,
    data: {
      themeId,
    },
    meta: getAnalyticsMeta(INSTRUMENTATION_TYPES.ACTION_WITH_DATA, {
      linkName: 'save_theme',
      pageGroup,
      pageName,
      data,
    }),
  }
}
